<template lang="pug">
PageBook(:showAuthor="false")

  figure.col.col7.left-image
    img.mt5(src="./Rolandskvadet_Rolandskvadet.jpg" alt="Grupper av riddarar i eit landskap med åsryggar og skog. Illustrasjon")
    figcaption Åtte hendingar frå «Rolandskvadet» samla i eitt bilete

  p «Rolandskvadet» er det eldste bevarte franske heltediktet, og det mest kjende. Kvadet vart skrive ned rundt år 1100 og handlar om Karl den store og dei tolv kjempene hans, mellom dei Roland og Holger Danske. Teksten finst i fleire versjonar. Den lengste er på 4000 verselinjer.

  p Kvadet er omsett til norrønt («Karlamagnús saga»), og det finst ein norsk versjon frå 1934. Vi finn historia om Roland også i folkevisa «Roland og Magnus kongjen». Magnus kongjen er Karl den store («magnus» tyder ‘den store’ på latin).

  p Diktaren er ein elles ukjend mann ved namn Turold (Thorvald). Namnet kan tyde på at han var frå Normandie, den delen av Frankrike som vart erobra av vikingar på 900-talet. Desse vikingane blanda seg med folket på staden og gjekk over til å snakke fransk.

  a(href="media/books/rolandskvadet/roland.html" target="_blank") Les heile kvadet

  h3 Handlinga i kvadet
  p Roland er nevø av Karl den store og leiar for baktroppen i hæren til keisaren. Keisaren er med hæren sin på veg tilbake frå Spania over Pyreneane. Ein svikar får ordna eit overfall på Roland og baktroppen frå maurarane. Roland har eit horn, Olifant, som han kan bruke for å tilkalle hovudtroppen. Men han nektar først å bruke hornet. Han er overmodig og trur han kan slå fienden utan hjelp. Roland og mennene hans maktar å drive maurarane på flukt, men prisen for sigeren er høg: Alle som ein fell i kampen.

  p Når mest alle mennene hans er døde, blæs Roland i hornet. Han vil at keisaren skal hemne han og dei andre døde. Det gjer Karl den store: Han nedkjempar fienden og straffar svikaren og ætta hans. Før Roland døyr, vedgår han at han har synda. Det er han som er skuldig i at alle mennene er døde, han burde ikkje ha venta med å blåse i hornet for å tilkalle hjelp. Han rekkjer hansken sin til Gud, og Gud tek imot hansken. Gud har gjort Rolands overmodige handling til ein reiskap for kristendommen: Fienden er slått tilbake.

  h3 Historisk bakgrunn for «Rolandskvadet»
  figure.col.col7.right-image.mt5
    img(src="./Rolandskvadet_Grandes_chroniques_de_France.jpg" alt="Ein riddar ber for ein døande person. I bakgrunnen går det føre seg eit slag. Illustrasjon")
    figcaption Slaget ved Roncesvalles i 778. Rolands død, frå «Grandes chroniques de France», miniatyrmåleri av Jean Fouquet.

  p Vi har berre éi historisk kjelde som fortel om Roland, og det er Einhard, ein lærd historikar som skreiv ein biografi om Karl den store få år etter at keisaren var død. I 778 drog Karl den store på eit felttog mot maurarane (arabarane), som hadde erobra store delar av Spania. På veg attende til Frankrike vart baktroppen hans overfallen ved Roncesvalles, eit fjellpass i Pyreneane. Det var baskarar, ikkje maurarar, som stod bak overfallet.

  p Einhard nemner i biografien at både Hruodland, som var markgreve iBritannia (Bretagne), og fleire andre vart drepne i slaget ved Roncesvalles i 778. Det gjekk mange hundre år før dei kristne vann tilbake Spania og Portugal. Først i 1492 vart den siste mauriske herskaren kasta ut av Granada.

  h3 Chansons de geste
  figure.col.col7.right-image.mt5
    img(src="./Rolandskvadet_Chanson_de_Roland.jpg" alt="Riddar med venger sit på ein hest. Ein soldat held ein skada soldat i fanget. Over dette handskrive tekst. Faksimile")
    figcaption Eit fargelagt manuskript til 
      em Chanson de Roland
      | , frå 1300-talet

  p Franskmennene kallar heltedikta 
    em Chansons de geste
    | . Det kan vi omsetje med songar om (helte)dådar. Mange av dei gammalfranske heltedikta handlar om Karl den store (742–814) og kampane hans mot heidningar, særleg i Spania. Heltedikta var opphavleg skrivne som propaganda for felttoga mot maurarane (arabarane) i Spania på 1000-talet.

  p Kjeldene er historiske forteljingar, men dei er gitt att svært fritt.Det er bevart om lag 200 gammalfranske heltedikt frå perioden 1050 til 1350 (høgmellomalderen).

  p Heltedikta var populær underhaldning. Dei vart sungne av omvandrandesongarar og spelemenn, såkalla sjonglørar.



</template>

<script>
import PageBook from "@/components/PageBook";
import NdlaVideo from "@/components/NdlaVideo";
import NdlaAudio from "@/components/NdlaAudio";

export default {
  name: "Book",
  components: {
    NdlaAudio,
    NdlaVideo,
    PageBook,
  },
};
</script>

<style lang="scss" scoped></style>
